import React, { ReactNode } from "react";
import styled from "styled-components";
import useDrawerContext from "./useDrawerContext";

type DrawerContentProps = {
  children: ReactNode;
};

const DrawerContent = (props: DrawerContentProps) => {
  const { children } = props;
  const { isOpen } = useDrawerContext();

  return (
    <DrawerContentWrapper isOpen={isOpen}>{children}</DrawerContentWrapper>
  );
};

type DrawerContentWrapperProps = {
  isOpen: boolean;
};

const DrawerContentWrapper = styled.div<DrawerContentWrapperProps>`
  position: absolute;
  background: white;
  top: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  max-width: 100%;
  padding: 2rem;
  overflow-y: auto;

  transition: transform 180ms ease-in-out;
  transform: translateX(${({ isOpen }) => (isOpen ? "0" : "100%")});
`;

export default DrawerContent;
